import React from 'react'
import {WysiwygType} from 'types'
import {FormText} from '../../layout/Form'

export type TextType = {
	text: WysiwygType
}

export const Text: React.FC<TextType> = ({text}) => <FormText text={text} />
